<template>
  <div>

    <div class="page-wrapper" id="pageWrapper" :class="layoutobj">
      <div class="page-header" :class="{ close_icon: !togglesidebar, 'page-header--enhanced': shouldUseEnhancedSidebar }">
        <Header @clicked="sidebar_toggle" />
      </div>
      <div class="page-body-wrapper">
        <div
          v-show="togglesidebar"
          class="sidebar-overlay"
          role="button"
          tabindex="-1"
          aria-label="Close sidebar"
          @click="hidesecondmenu()"
        />
        <div class="sidebar-wrapper" :class="[{ close_icon: !togglesidebar, 'sidebar-hidden': !togglesidebar, 'sidebar-wrapper--enhanced': shouldUseEnhancedSidebar }]"
          :sidebar-layout="svg == 'stroke-svg' ? 'stroke-svg' : 'fill-svg'">
          <Sidebar @clicked="sidebar_toggle" />
        </div>
        <div class="page-body" :class="{ 'portal-brand-theme': shouldUseEnhancedSidebar }" @click="hidesecondmenu()">
          <transition name="fadeIn" enter-active-class="animated fadeIn">
            <div>
              <BreadCrumbsNew />
              <router-view></router-view>
            </div>
          </transition>
        </div>
        <Footer />
      </div>
      <TapTop />
      <AiChatWidget />
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import config from '@/data/layout.json';
import { layoutClasses } from '../constants/layout';
import Header from './header/index.vue';
import Sidebar from './sidebar/index.vue';
import Footer from './footer.vue';
import TapTop from './tapTop.vue';
import BreadCrumbsNew from '@/components/BreadCrumbsNew.vue';
import AiChatWidget from './ai-chat/AiChatWidget.vue';
import '@/assets/scss/components/_portal-brand-theme.scss';
export default {
  name: 'mainpage',
  props: ['sidebar_toggle_var'],
  components: {
    Header,
    Sidebar,
    Footer,
    TapTop,
    BreadCrumbsNew,
    AiChatWidget,
  },
  data() {
    return {
      loading: true,
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      horizontal_Sidebar: true,
      resized: false,
      layoutobj: {}
    };
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
      togglesidebar: (state) => state.menu.togglesidebar,
      activeoverlay: (state) => state.menu.activeoverlay,
      svg: (state) => state.layout.svg,
    }),
    ...mapGetters({
      sidebar: 'layout/sidebar'
    }),
    layoutobject: {
      get: function () {
        return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
        return this.layoutobj;
      }
    },
    shouldUseEnhancedSidebar() {
      try {
        const userAddData = JSON.parse(localStorage.getItem('userAddData') || 'null');
        const partnerTypes = userAddData?.partnerTypes || [];
        const userGroup = userAddData?.userGroup;
        const isInternalUser = partnerTypes.includes('RYD_INTERNAL') || userGroup === 'ryd';
        const isFleetPartner = partnerTypes.includes('FLEET_PARTNER') && !isInternalUser;
        return !isFleetPartner;
      } catch {
        return true;
      }
    },
  },

  watch: {
    '$route'() {
      this.menuItems.filter(items => {
        if (items.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', items);
        if (!items.children) return false;
        items.children.filter(subItems => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch('menu/setActiveRoute', subSubItems);
          });
        });
      });
      this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);

      if ((window.innerWidth < 991 && this.layout.settings.layout === 'LosAngeles') || (window.innerWidth < 991 && this.layout.settings.layout === 'Singapore') || (window.innerWidth < 991 && this.layout.settings.layout === 'Barcelona')) {
        const newlayout = JSON.parse(JSON.stringify(this.layoutobj).replace('horizontal-wrapper', 'compact-wrapper'));

        this.layoutobj = JSON.parse(JSON.stringify(newlayout))[this.layout.settings.layout];
      } else {
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
      }
    },
    sidebar_toggle_var: function () {
      this.resized = (this.width <= 991) ? !this.sidebar_toggle_var : this.sidebar_toggle_var;
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.resized = this.sidebar_toggle_var;
    this.$store.dispatch('layout/set');
    this.layout.settings.layout = this.$route.query.layout ? this.$route.query.layout : config.settings.layout;
    this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
    this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
  },
  methods: {
    sidebar_toggle(value) {
      this.sidebar_toggle_var = !value;
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value;
    },
    handleResize() {
      this.$store.dispatch('menu/resizetoggle');
    },
    removeoverlay() {
      this.$store.state.menu.activeoverlay = false;
      if (window.innerWidth < 991) {
        if (this.$store.state.menu.togglesidebar) {
          this.$store.dispatch('menu/opensidebar');
        }
      }
      this.menuItems.filter(menuItem => {
        menuItem.active = false;
      });
    },
    hidesecondmenu() {
      if (this.layoutobject.split(' ').includes('compact-sidebar')) {
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      }
      if (window.innerWidth < 1007) {
        if (this.$store.state.menu.togglesidebar) {
          this.$store.dispatch('menu/opensidebar');
        }
      }
    }
  },

};
</script>

<style scoped>
/* Custom CSS to completely hide the sidebar when toggled */
.sidebar-wrapper.sidebar-hidden {
  width: 0 !important;
  overflow: hidden !important;
  transition: width 0.3s ease !important;

}

.sidebar-wrapper.sidebar-hidden ~ .page-body,
.sidebar-wrapper.sidebar-hidden ~ footer {
  margin-left: 0 !important;
  transition: margin-left 0.3s ease !important;
}

/* For RTL layouts */
[dir=rtl] .sidebar-wrapper.sidebar-hidden ~ .page-body,
[dir=rtl] .sidebar-wrapper.sidebar-hidden ~ footer {
  margin-right: 0 !important;
  margin-left: unset !important;
  transition: margin-right 0.3s ease !important;
}

/* Ensure footer width adjusts when sidebar is hidden */
.sidebar-wrapper.sidebar-hidden ~ .footer-fix {
  width: 100% !important;
  transition: width 0.3s ease !important;
}

/* Show sidebar when not hidden - fleet partner (standard width) */
.sidebar-wrapper:not(.sidebar-hidden) {
  width: 265px !important;
  transition: width 0.3s ease !important;
}

.sidebar-wrapper:not(.sidebar-hidden) ~ .page-body,
.sidebar-wrapper:not(.sidebar-hidden) ~ footer {
  margin-left: 265px !important;
  transition: margin-left 0.3s ease !important;
}

[dir=rtl] .sidebar-wrapper:not(.sidebar-hidden) ~ .page-body,
[dir=rtl] .sidebar-wrapper:not(.sidebar-hidden) ~ footer {
  margin-right: 265px !important;
  margin-left: unset !important;
  transition: margin-right 0.3s ease !important;
}

.sidebar-wrapper:not(.sidebar-hidden) ~ .footer-fix {
  width: calc(100% - 265px) !important;
  transition: width 0.3s ease !important;
}

/* Enhanced sidebar (non-fleet partners) — wider */
.sidebar-wrapper--enhanced:not(.sidebar-hidden) {
  width: 290px !important;
}

.sidebar-wrapper--enhanced:not(.sidebar-hidden) ~ .page-body,
.sidebar-wrapper--enhanced:not(.sidebar-hidden) ~ footer {
  margin-left: 290px !important;
}

[dir=rtl] .sidebar-wrapper--enhanced:not(.sidebar-hidden) ~ .page-body,
[dir=rtl] .sidebar-wrapper--enhanced:not(.sidebar-hidden) ~ footer {
  margin-right: 290px !important;
  margin-left: unset !important;
}

.sidebar-wrapper--enhanced:not(.sidebar-hidden) ~ .footer-fix {
  width: calc(100% - 290px) !important;
}

/* Page header offset for enhanced sidebar */
.page-header--enhanced:not(.close_icon) {
  margin-left: 290px !important;
  width: calc(100% - 290px) !important;
}

/* Sidebar overlay - only visible in overlap mode */
.sidebar-overlay {
  display: none;
}

/* At narrow widths, sidebar overlaps content instead of pushing it */
@media (max-width: 1007px) {
  .sidebar-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 98;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .sidebar-wrapper:not(.sidebar-hidden) {
    position: fixed !important;
    z-index: 1000 !important;
    height: 100vh !important;
    display: flex;
    flex-direction: column;
  }

  .sidebar-wrapper:not(.sidebar-hidden) :deep(> div) {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .sidebar-wrapper:not(.sidebar-hidden) :deep(.sidebar-main) {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .sidebar-wrapper:not(.sidebar-hidden) :deep(#sidebar-menu) {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .sidebar-wrapper:not(.sidebar-hidden) :deep(.sidebar-links) {
    flex: 1;
    overflow-y: auto;
  }

  .sidebar-wrapper:not(.sidebar-hidden) ~ .page-body,
  .sidebar-wrapper:not(.sidebar-hidden) ~ footer {
    margin-left: 0 !important;
  }

  .sidebar-wrapper:not(.sidebar-hidden) ~ .footer-fix {
    width: 100% !important;
  }

  [dir=rtl] .sidebar-wrapper:not(.sidebar-hidden) ~ .page-body,
  [dir=rtl] .sidebar-wrapper:not(.sidebar-hidden) ~ footer {
    margin-right: 0 !important;
    margin-left: unset !important;
  }
}

/* Hide the hamburger menu when sidebar is completely hidden */
.page-header.close_icon :deep(.toggle-sidebar) {
  display: none !important;
}
</style>

